import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { THShield } from 'src/theme/media';
import * as S from './Styles';

export const ExpiredLinkSentPage: FC = () => {
  const history = useHistory();

  const handleRequestNewLink = () => {
    history.push('/forgotten_password');
  };

  return (
    <S.PageContainer>
      <S.PageTitle>A new login link is on its way!</S.PageTitle>
      <S.PageContentContainer>
        <p>
          Your previous link has expired, so we’ve automatically sent a new one
          to your email. Please check your inbox for the replacement link.
        </p>
      </S.PageContentContainer>
      <S.PageBottomContainer>
        <S.PageShieldImage src={THShield} />
        <S.FooterText>
          If you don't receive a new link within 10 minutes:{' '}
          <span onClick={handleRequestNewLink}>Request a new link</span>
        </S.FooterText>
      </S.PageBottomContainer>
    </S.PageContainer>
  );
};
